import React from 'react';
import { Minus, Plus, ShieldCheck } from 'lucide-react';
import VisualBarbell from './VisualBarbell';

export default function WorkoutModals({
    weightModal, setWeightModal, updateSetData,
    showConfirmModal, setShowConfirmModal, logWorkoutWithDetails
}) {
    const handleSaveWeight = (e) => {
        if (e) e.preventDefault();
        const parsed = parseFloat(String(weightModal.weight).replace(',', '.'));
        updateSetData(weightModal.key, weightModal.sIdx, 'weight', isNaN(parsed) ? 0 : Math.max(0, parsed));
        setWeightModal({ isOpen: false, key: null, sIdx: null, weight: 0, isBarbell: false, barWeight: 20 });
    };

    return (
        <>
            {weightModal.isOpen && (
                <div className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 z-[999999]">
                    <form onSubmit={handleSaveWeight} className="bg-zinc-900 border border-zinc-700 p-6 rounded-2xl w-full max-w-sm shadow-2xl relative">
                        <h3 className="text-xl font-black text-white mb-5 text-center uppercase tracking-wider">Gewicht Aanpassen</h3>

                        <div className="flex items-center justify-center gap-4 mb-5">
                            <button
                                type="button"
                                onClick={() => setWeightModal({ ...weightModal, weight: Math.max(0, Math.round(((parseFloat(weightModal.weight) || 0) - 2.5) * 100) / 100) })}
                                className="w-12 h-12 bg-red-500/20 text-red-500 border border-red-500/30 rounded-xl flex items-center justify-center transition-colors hover:bg-red-500/30 active:scale-95 shrink-0"
                            >
                                <Minus size={24}/>
                            </button>
                            <input
                                type="number"
                                step="any"
                                value={weightModal.weight}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => setWeightModal({ ...weightModal, weight: e.target.value })}
                                className="w-28 text-center text-3xl sm:text-4xl font-black text-white bg-zinc-800 rounded-xl py-2 outline-none border-2 border-orange-500 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                autoFocus
                            />
                            <button
                                type="button"
                                onClick={() => setWeightModal({ ...weightModal, weight: Math.round(((parseFloat(weightModal.weight) || 0) + 2.5) * 100) / 100 })}
                                className="w-12 h-12 bg-emerald-500/20 text-emerald-500 border border-emerald-500/30 rounded-xl flex items-center justify-center transition-colors hover:bg-emerald-500/30 active:scale-95 shrink-0"
                            >
                                <Plus size={24}/>
                            </button>
                        </div>

                        {weightModal.isBarbell && (
                            <div className="bg-zinc-800/60 p-4 rounded-xl border border-zinc-700 mb-5">
                                <div className="flex justify-between items-center mb-4 border-b border-zinc-700 pb-2">
                                    <span className="text-xs sm:text-sm font-bold text-gray-300">Stang (Barbell):</span>
                                    <select
                                        value={weightModal.barWeight}
                                        onChange={(e) => setWeightModal({ ...weightModal, barWeight: parseInt(e.target.value, 10) })}
                                        className="bg-zinc-900 text-white text-xs px-2.5 py-1.5 rounded-lg outline-none border border-zinc-600 focus:border-orange-500 cursor-pointer font-bold"
                                    >
                                        <option value={20}>20 kg (Heren)</option>
                                        <option value={15}>15 kg (Dames)</option>
                                        <option value={10}>10 kg (Techniek)</option>
                                        <option value={0}>0 kg (Geen Barbell)</option>
                                    </select>
                                </div>
                                <div className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 text-center">Platen per kant</div>
                                <VisualBarbell weight={parseFloat(weightModal.weight) || 0} barWeight={weightModal.barWeight} />
                            </div>
                        )}

                        <div className="flex gap-3 mt-4">
                            <button
                                type="button"
                                onClick={() => setWeightModal({ isOpen: false, key: null, sIdx: null, weight: 0, isBarbell: false, barWeight: 20 })}
                                className="flex-1 py-3.5 bg-zinc-800 hover:bg-zinc-700 transition-colors rounded-xl font-bold text-gray-300 border border-zinc-700"
                            >
                                Annuleren
                            </button>
                            <button
                                type="submit"
                                className="flex-1 py-3.5 bg-green-600 hover:bg-green-500 transition-colors rounded-xl font-black text-white shadow-lg"
                            >
                                Opslaan
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {showConfirmModal && (
                <div className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 z-[999999]">
                    <div className="bg-zinc-900 border border-zinc-700 p-8 rounded-2xl w-full max-w-md text-center shadow-2xl relative mb-20">
                        <ShieldCheck size={64} className="mx-auto text-green-500 mb-4" />
                        <h3 className="text-2xl font-black text-white mb-2">Workout Opslaan?</h3>
                        <p className="text-gray-400 mb-8 text-sm">Alle voltooide sets en je PR's worden direct vastgelegd.</p>
                        <div className="flex flex-col gap-3">
                            <button onClick={() => logWorkoutWithDetails()} className="w-full py-4 bg-green-600 hover:bg-green-500 rounded-xl font-black text-lg text-white shadow-xl transition-colors">Ja, sla op!</button>
                            <button onClick={() => setShowConfirmModal(false)} className="w-full py-4 bg-zinc-800 hover:bg-zinc-700 rounded-xl font-bold text-gray-300 border border-zinc-700 transition-colors">Nog niet klaar</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
